import React, { ReactNode } from 'react';
import { ListItem } from '../../components/List';
import { SvgIcon } from '../../components/SvgIcon';

export const TextBreak = () => <br />;

interface ListItemWithIconProps {
  children?: ReactNode;
}

export const ListItemWithIcon = (props: ListItemWithIconProps) => (
  <ListItem {...props}>
    <SvgIcon icon="check" />
    <span>{props.children}</span>
  </ListItem>
);
